import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';
import { NgFor, NgIf } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { BannerSectionType01Component } from "../../banner-section/banner_section-type01/banner_section-type01.component";
import { MapType01Component } from "../../map/map-type01/map-type01.component";
import { members } from '../member-info';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-members-type01',
  standalone: true,
  imports: [MatIconModule, HeadingSectionType01Component, FuseCardComponent, NgFor, GoogleMapsModule, BannerSectionType01Component, MapType01Component, NgIf, FormsModule],
  templateUrl: './members-type01.component.html',
  styleUrl: './members-type01.component.scss'
})
export class MembersType01Component {

  //    mapOptions: google.maps.MapOptions = {
  //   styles: [
  //     {
  //       "featureType": "water",
  //       "stylers": [
  //         { "color": "accent" } // Water color
  //       ]
  //     },
  //     {
  //       "featureType": "road",
  //       "elementType": "geometry",
  //       "stylers": [
  //         { "color": "primary" } // Road color
  //       ]
  //     },
  //     {
  //       "featureType": "landscape",
  //       "stylers": [
  //         { "color": "accent" } // Land color
  //       ]
  //     },
  //     {
  //       "featureType": "poi.park",
  //       "stylers": [
  //         { "color": "#9be7c3" } // Park color
  //       ]
  //     },
  //     {
  //       "featureType": "administrative",
  //       "elementType": "labels.text.fill",
  //       "stylers": [
  //         { "color": "#444444" } // Text color
  //       ]
  //     }
  //   ],
  //   disableDefaultUI: true, // Optionally hide default UI controls like zoom and map type
  //   zoomControl: true, // Enable zoom control
  // };

  regionCounts: { [region: string]: number } = {};

  regionList: string[] = [
    'Eastern Cape',
    'Free State',
    'Gauteng',
    'Limpopo',
    'Mpumalanga',
    'KwaZulu-Natal',
    'North West',
    'Western Cape',
    'Botswana',
    'Eswatini',
    'Namibia',
    'Zambia',
  ];

  public view: any = {
    title: 'Our Members',
    defaultLat: -27.991448970021764,
    defaultLng: 26.75858065791476,
    mapBounds: null as { south: number; west: number; north: number; east: number } | null,
    // locations: [
    //   { lat: -26.2426705296327, lng: 28.246879880202858 },  //XL Boksburg Travel
    //   { lat: -26.15251801582328, lng: 28.337870574144677 }, //XL Elite Travel
    //   { lat: -25.859489982353367, lng: 28.176536263303085 },  //XL Centurion Travel
    //   { lat: -26.1587366129588, lng: 28.058879592546695 },  //XL Fly Now Travel - Houghton  
    //   { lat: -25.78501730788294, lng: 28.281182142499855 },  //XL Glenwood Travel (Menlyn Maine) , 

    //   { lat: -29.832139010876556, lng: 31.016155872131577 },  //XL Nexus Travel - Durban
    //   { lat: -33.871994384188824, lng: 18.520065470074645 },  //XL Sandown Travel - Cape Town , 
    //   { lat: -22.53412339666899, lng: 17.10089160341932 },  //XL The Travel Professionals - Namibia , 
    //   { lat: -25.78501730788294, lng: 28.281182142499855 },  //XL Wild Travel
    //   { lat: -29.108035165386234, lng: 26.213584474633613 },  //XL Astra Travel - Bloemfontein (Head Office) ,
    // ],
    map: {
      maxZoom: 20,
      style: [
        {
          "stylers": [
            {
              "hue": "#ffb718"
            },
            {
              "saturation": 50
            }
          ]
        },
        {
          "featureType": "water",
          "stylers": [
            {
              //"color": "#f0f4f9"
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "administrative.country",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }
      ]
    }

  }

  constructor(private _tfmService: TFMService, private title: Title, private metaService: Meta) { }

  ngOnInit(): void {

    this._tfmService.getContentBySection('about').then(res => {
      this.view.page = res;
      console.log(this.view.page);

      if (this.view.page) {

        //Set title
        this.title.setTitle('Our Members' + " - " + this.view.site?.name);

        // Set description & keywords
        this.metaService.updateTag({ name: 'description', content: this.view.page.content.seo.description });
        this.metaService.updateTag({ name: 'keywords', content: this.view.page.content.seo.keywords });
      }

    });

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      // console.log(this.view.site);

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);

    });

    this.loadMembers();

    // this._tfmService.send({
    //     href: 'https://xl-api-s.travelfind.me/api/member',
    //     method: 'get',
    //     rel: ''
    //   }).subscribe(
    //     (res) => {
    //       this.view.brances = res;
    //       this.view.filteredCardDataList = this.view.brances;
    //       this.view.originalCardDataList = this.view.brances;

    //       this._tfmService.log('Success:', this.view.brances);
    //     },
    //     (error) => {
    //       console.error('Error:', error);
    //     }
    //   );
  }
 
  // filteredCardDataList = this.view.brances;
  // filteredCardDataList = this.cardDataList;
  // loadMembers(): void {
  //     const sortedMembers = [...members].sort((a, b) =>
  //         a.name.localeCompare(b.name)
  //     );
  //     // this.view.brances = sortedMembers;
  //     this.view.brances = members;
  //     this.view.filteredCardDataList = this.view.brances;
  //     this.view.originalCardDataList = this.view.brances;
  //     //  this.updateMapLocations();
  //     //  this.filterCards()
  //     this.view.locations = this.view.filteredCardDataList;
  //     console.log(this.view.locations);
  // }

  loadMembers(): void {
    const sortedMembers = [...members].sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    this.view.branches = sortedMembers;
    this.view.filteredCardDataList = this.view.branches;
    this.view.originalCardDataList = this.view.branches;

    // Extract all member if, for latitude and longitude (ask hugo about hover effect over pin)
    this.view.locations = sortedMembers.flatMap(member => {
      if (!member || !Array.isArray(member.details)) return [];

      return member.details
        .filter(d => d.lat && d.long)
        .map(d => ({
          lat: Number(d.lat),
          long: Number(d.long),
          title: member.name, // for hover effect
        }));
    });

    this.updateMapLocations();
  }

  selectedRegions: string[] = [];
  searchQuery: string = '';
  searchSuggestions: any[] = [];
  showSuggestions = false;

  onRegionChange(region: string, event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      this.selectedRegions = [region];
    } else {
      this.selectedRegions = [];
    }
    this.filterCards();
    this.updateMapLocations();
  }

  onSearchQueryChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.onSearchInput(value);
  }

  onSearchInput(value: string): void {
    this.searchQuery = value;
    const matches = this.getMatchingCards();
    this.searchSuggestions = matches.slice(0, 10);
    this.showSuggestions = value.length > 0;
    this.view.filteredCardDataList = matches;
    this.calculateRegionCounts();
    this.updateMapLocations();
  }

  getMatchingCards(): any[] {
    const query = this.searchQuery.toLowerCase();
    return this.view.originalCardDataList.filter((card: any) => {
      const details = Array.isArray(card?.details) ? card.details : [];
      const matchesRegion =
        this.selectedRegions.length === 0 ||
        details.some((d: any) => this.selectedRegions.includes(d.province)) ||
        this.selectedRegions.includes(card?.country);
      const matchesQuery =
        !query ||
        card?.name?.toLowerCase().includes(query) ||
        details.some((d: any) =>
          d.address?.toLowerCase().includes(query) ||
          d.phone?.includes(query)
        );
      return matchesRegion && matchesQuery;
    });
  }

  selectSuggestion(card: any): void {
    this.searchQuery = card.name;
    this.showSuggestions = false;
    this.filterCards();
    this.updateMapLocations();
  }

  hideSuggestionsLater(): void {
    setTimeout(() => this.showSuggestions = false, 150);
  }

  resetFilters(): void {
    this.searchQuery = '';
    this.selectedRegions = [];
    this.showSuggestions = false;
    this.searchSuggestions = [];
    this.filterCards();
    this.updateMapLocations();
    // New object so map component's ngOnChanges always fires and fitBounds runs
    this.view.mapBounds = { ...this.southAfricaBounds };
  }

  /** Bounds that frame South Africa for map recenter */
  private readonly southAfricaBounds = {
    south: -35,
    north: -22,
    west: 16,
    east: 33,
  };

  /** Predefined map bounds per region (used when exactly one region is selected) */
  private readonly regionBounds: Record<string, { south: number; north: number; west: number; east: number }> = {
    'Western Cape': {
      south: -34.784180548975776,
      north: -32.348834975076024,
      west: 17.905687222090304,
      east: 22.708105728291667,
    },
  };

  //   filterCards() {
  //       this.view.filteredCardDataList = this.view.originalCardDataList.filter(card => {
  //           const matchesQuery = card.name.toLowerCase().includes(this.searchQuery);

  //           return matchesQuery;
  //       });
  // }

  filterCards() {
    this.view.filteredCardDataList = this.getMatchingCards();
    this.updateMapLocations();
  }

  updateMapLocations() {
    this.view.locations = this.view.filteredCardDataList
      .filter(card => card.details && card.details.length && card.details[0].lat && card.details[0].long)
      .map(card => ({
        lat: parseFloat(card.details[0].lat),
        lng: parseFloat(card.details[0].long),
        title: card.name,
      }));

    if (this.view.locations.length > 0) {
      this.view.defaultLat = this.view.locations[0].lat;
      this.view.defaultLng = this.view.locations[0].lng;
      this.view.map.zoom = 12;
    }

    const predefined = this.selectedRegions.length === 1 && this.regionBounds[this.selectedRegions[0]];
    if (predefined) {
      this.view.mapBounds = { ...this.regionBounds[this.selectedRegions[0]] };
    } else if (this.view.locations.length > 0) {
      const lats = this.view.locations.map((l: { lat: number }) => l.lat);
      const lngs = this.view.locations.map((l: { lng: number }) => l.lng);
      const padding = 0.1;
      const latSpan = Math.max(...lats) - Math.min(...lats) || 0.5;
      const lngSpan = Math.max(...lngs) - Math.min(...lngs) || 0.5;
      this.view.mapBounds = {
        south: Math.min(...lats) - padding * latSpan,
        north: Math.max(...lats) + padding * latSpan,
        west: Math.min(...lngs) - padding * lngSpan,
        east: Math.max(...lngs) + padding * lngSpan,
      };
    } else {
      this.view.mapBounds = null;
    }
  }

  calculateRegionCounts() {
    const counts: { [region: string]: number } = {};

    for (const card of this.view.originalCardDataList) {
      for (const detail of card?.details || []) {
        const province = detail.province;
        if (province) {
          counts[province] = (counts[province] || 0) + 1;
        }
      }
    }
    this.regionCounts = counts;
  }

}